import styled from 'styled-components';

export const IconWrapper = styled.div<{ status: string }>`
  .MuiSvgIcon-root {
    font-size: 28px;
    color: ${({ status }) => {
      switch (status) {
        case 'APPROVED':
          return '#29CC97';
        case 'REJECTED':
          return '#FF6565';
        case 'SKIPPED':
          return 'rgba(0,0,0,0.28)';
        default:
          return '';
      }
    }};
  }
`;
export const HelpIconWrapper = styled.div`
  .MuiSvgIcon-root {
    position: absolute;
    left: -6px;
    margin-top: 2px;
    font-size: 13px;
    color: #929395;

    &:hover {
      color: #000;
    }
  }
`;

export const HelpContent = styled.div`
  width: 460px;
  padding: 10px 18px;
  font-size: 14px;
  line-height: 20px;
`;